import Service from "../Service";

const chartdata = {

    getAllChartData(){
        return Service.get(`/api/creative/export`);
    },
    getChartData(id,year){
        return Service.get(`/api/detail/industry?industry_id=${id}&year=${year}`);
    },
    getAllIndustriesByYear(year) {
        return Service.get(`/api/creative/export/byyear?year=${year}`);
    },
    getGDPThailand() {
        return Service.get('/api/gdp/export');
    },
    getLaborData() {
        return Service.get('/api/creative/job');
    },
    getIndustryChart(id) {
        return Service.get(`/api/creative/industry?industry_id=${id}`);
    },

    getGraphByYear(year) {
        return Service.get(`/api/frontend/statistic?year_data=${year}`)
    },

    uploadChartImage(image, filename) {
        return Service.post(`/api/chart-image/${filename}`, {
            image: image
        })
    }
};

export default chartdata;
